/** Typed SWR cache keys (#240): values, not strings, so the read hook and the mutation that repopulates it agree. */
export const auditKeys = {
  list: ['audits'] as const,
  detail: (auditId: string) => ['audits', auditId] as const,
  stages: (auditId: string) => ['audits', auditId, 'stages'] as const,
  reviews: (auditId: string) => ['audits', auditId, 'reviews'] as const,
  pipelines: ['audits', 'pipelines'] as const,
  backfill: (pipelineId: string) => ['audits', 'backfill', pipelineId] as const,
  card: (auditId: string, cardId: string) => ['audits', auditId, 'cards', cardId] as const,
  review: (auditId: string) => ['audits', auditId, 'review'] as const,
  chat: (auditId: string) => ['audits', auditId, 'chat'] as const,
  brain: (auditId: string) => ['audits', auditId, 'brain'] as const,
}
